/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useMemo, useState} from 'react'
import {render} from 'react-dom'
import {Column} from 'react-table'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import Swal from 'sweetalert2'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {TabModel} from '../../../../../../models'
import {getSnackBar, getSnackBarToast} from '../../../../../../util/snackBar'
import {CampModel, ClientModel, CompanyModel, SiteModel} from '../../../../../central/model'
import {getCamp, getClient, getCompany, getSite} from '../../../../../central/services'
import {CheckingModel} from '../../../../models/ckecking.model'
import ActionsContent from '../../../../pages/components/Actions'
import {downloadPDFCheckInOutService} from '../../../../services/booking.service'
import {createCheckoutService, getCheckingService} from '../../../../services/checking.service'
import {ModalSearchHuesped} from '../../../checking/components/Modal/ModalSearchHuesped'
import {paginationGuestsService} from '../../../guests/services'
import {getMasterModuleService} from '../../../modules/services'
import {FormMasiveUploadCheckout} from '../Forms/FormMasiveUploadCheckout'

interface SelectOption {
  value: string | number | undefined
  label: string | undefined
}

const TableCheckout: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    pagination,
    clearSelected,
    updateTable,
    setUpdateTable,
    clearTable,
    setClearTable,
  } = useKTable()
  const {changeCurrentTabItem, currentTabItem, showModalSearch, setShowModalSearch, isAllowed} =
    useHoteleria()
  const {selectedOn} = useKTable()
  const {changeSearchValues, searchValues, clearSearchValues} = useKhipu()
  const [compani, setCompany] = useState<SelectOption[]>([])
  const [client, setClient] = useState<SelectOption[]>([])
  const [site, setSite] = useState<SelectOption[]>([])
  const [camp, setCamp] = useState<SelectOption[]>([])
  const [bedTypes, setBedTypes] = useState<SelectOption[]>([])
  const [companyType, setCompanyType] = useState<SelectOption[]>([])
  const [statusType, setStatusType] = useState<SelectOption[]>([])
  const [guestTypes, setGuestTypes] = useState<SelectOption[]>([])
  const [guest, setGuest] = useState<SelectOption[]>([])
  const [selectedItem, setSelectedItem] = useState<any>(null)

  const handleSearch = () => {
    setShowModalSearch(true)
  }
  ///

  const getCompanyList = async () => {
    let obj: CompanyModel = {
      isCombo: true,
    }
    const response = await getCompany(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({
      value: item.id,
      label: item.nombreEmpresa,
    }))
    setCompany(mappedSites)
  }

  const getClientList = async () => {
    //await new Promise(resolve => setTimeout(resolve, 2000));
    let obj: ClientModel = {
      isCombo: true,
    }
    const response = await getClient(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setClient(mappedSites)
  }

  const getSiteList = async () => {
    let obj: SiteModel = {
      isCombo: true,
    }
    const response = await getSite(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setSite(mappedSites)
  }
  const getCampList = async () => {
    let obj: CampModel = {
      isCombo: true,
    }
    const response = await getCamp(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setCamp(mappedSites)
  }

  const getBedTypes = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoCama',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      setBedTypes(mappedMaster)
    } catch (error) {
      setBedTypes([])
    }
  }

  const getCompanyTypes = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoEmpresa',
      })
      const data = response.data.data
      const mappedModuleTypes = data?.map((moduleType) => ({
        value: moduleType.id,
        label: moduleType.nombreCorto,
      }))
      setCompanyType(mappedModuleTypes)
    } catch (error) {
      setCompanyType([])
    }
  }

  const getStatusTypes = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        names: 'Check In',
        tableName: 'EstadoReservaHuesped',
      })
      const data = response.data.data
      const mappedModuleTypes = data?.map((moduleType) => ({
        value: moduleType.id,
        label: moduleType.nombreCorto,
      }))
      setStatusType(mappedModuleTypes)
    } catch (error) {
      setStatusType([])
    }
  }

  const getGuestTypes = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoHuesped',
      })
      const data = response.data.data
      const mappedModuleTypes = data?.map((moduleType) => ({
        value: moduleType.id,
        label: moduleType.nombreCorto,
      }))
      setGuestTypes(mappedModuleTypes)
    } catch (error) {
      setGuestTypes([])
    }
  }

  const getGuests = async (siteId: string) => {
    try {
      const {data: response} = await paginationGuestsService({
        pageNumber: 1,
        size: 2000,
        SiteId: siteId,
      })
      if (!response.error) {
        const mappedGuests = response.data?.map((guest) => ({
          value: guest.Id,
          label: `${guest.Nombres} ${guest.ApellidoPaterno} ${guest.ApellidoMaterno}`,
        }))
        setGuest(mappedGuests)
      }
    } catch (error) {
      setGuest([])
    }
  }

  ///

  const getChekings = async (dataFilter: any = null) => {
    setShowModalSearch(false)
    try {
      setLoading(true)
      // changeSearchValues({})
      const {data: response} = await getCheckingService({
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
        StatusCode: '3',
        ...dataFilter,
        ...searchValues,
      })
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
        // if (response.data.length === 0 && data){
        //   Swal.fire(
        //       'Ups!',
        //       'Parece que el huésped no tiene una reserva asignada!',
        //       'warning'
        //   )
        // }
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  // const getHuesped = (data: any) => {
  //   getChekings()
  // }

  const loadOptions = async (inputValue: string) => {
    try {
      if (inputValue.length < 3) {
        return []
      }
      const {data: response} = await paginationGuestsService({
        pageNumber: 1,
        size: 500,
        BuscaTexto: inputValue,
      })
      if (!response.error) {
        const mappedGuests = response.data?.map((guest) => ({
          value: guest.Id,
          label: `${guest.Nombres} ${guest.ApellidoPaterno} ${guest.ApellidoMaterno} ${guest.NumeroDocumento}`,
          ...guest,
        }))
        return mappedGuests
      } else {
        return []
      }
    } catch (error) {
      console.error('Error fetching options:', error)
      return []
    }
  }

  const handleGetId = (item: any) => {
    setSelectedItem(item)
    let idChange = item.ReservaCamaId === currentTabItem.idToDelete ? '' : item.ReservaCamaId
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }

  // const handleFilterClient = (e: any, name: string) => {
  //   let value = e.value
  //   getClientList(value)
  //   const {ClienteId, SiteId, CampamentoId, ...valuesSearch} = searchValues
  //   const nuevoObjeto = {...valuesSearch, [name]: value}
  //   changeSearchValues(nuevoObjeto)
  // }

  // const handleFilterSite = (e: any, name: string) => {
  //   let value = e.value
  //   getSiteList(value)
  //   const {SiteId, CampamentoId, ...valuesSearch} = searchValues
  //   const nuevoObjeto = {...valuesSearch, [name]: value}
  //   changeSearchValues(nuevoObjeto)
  // }

  const handleFilterCamp = (e: any, name: string) => {
    let value = e.value
    getGuests(value)
  }

  const handleFilterGuest = (e: any, name: string) => {
    let value = e.value
    const {HuespedId, ...valuesSearch} = searchValues
    const nuevoObjeto = {...valuesSearch, [name]: value}
    changeSearchValues(nuevoObjeto)
  }

  useEffect(() => {
    if (Object.keys(searchValues).length === 0) {
      getChekings()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValues])

  useEffect(() => {
    getChekings()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  // const handleShow = (data: CheckingModel) => {
  //   const obj: TabModel = {
  //     ...currentTabItem,
  //     showPanel: true,
  //     content: {
  //       ...currentTabItem.content,
  //       detailPanel: 'table-checkout-table',
  //     },
  //     idToDelete: '',
  //     idToEdit: data.ReservaCamaId,
  //     objectInfo: {
  //       ImpresionCheckOut: data.ImpresionCheckOut,
  //     },
  //   }
  //   changeCurrentTabItem(obj)
  // }

  const columns: Column<CheckingModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple
            id={props.data[props.row.index].ReservaCamaId}
            clickHandler={() => handleGetId(props.data[props.row.index])}
          />
        ),
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Módulo'
            name='CodigoModulo'
            searcheable
          />
        ),
        accessor: 'Modulo',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Habitación'
            name='CodigoHabitacion'
            searcheable
          />
        ),
        accessor: 'Habitacion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nomenclatura de Cama'
            name='CodigoCama'
            searcheable
          />
        ),
        accessor: 'CodigoCama',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de cama'
            name='TipoCamaId'
            selecteable
            data={bedTypes}
          />
        ),
        accessor: 'CamaTipo',
      },

      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nro Documento' name='NroDocumento' searcheable />
        ),
        accessor: 'NroDoc',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Huésped'
            name='HuespedId'
            selectLabel='HuespedLabel'
            selecteableAsync
            loadOptions={loadOptions}
            placeholder='Busca un Huésped...'
          />
        ),
        accessor: 'HuespedDescripcion',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha Inicio' name='FechaIni' dateable />
        ),
        accessor: 'FechaInicio',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha Fin' name='FechaFin' dateable />
        ),
        accessor: 'FechaFin',
      },
      // {
      //   Header: (props) => <KTableHeader tableProps={props} title='Estado' />,
      //   accessor: 'Estado',
      // },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estado de Reserva - Huésped'
            name='EstadoReservaId'
            selecteable
            data={statusType}
          />
        ),
        accessor: 'Estado',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estatus Huésped'
            name='TipoHuespedId'
            selecteable
            data={guestTypes}
          />
        ),
        accessor: 'TipoHuespedNombre',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Compañía'
            name='CompaniaId'
            selecteable
            data={compani}
          />
        ),
        accessor: 'Compania',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cliente'
            name={'ClienteId'}
            selecteable
            data={client}
          />
        ),
        accessor: 'Cliente',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Site'
            name={'SiteId'}
            selecteable
            data={site}
            onGetValueSelect={handleFilterCamp}
          />
        ),
        accessor: 'Site',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Campamento'
            name='CampamentoId'
            selecteable
            data={camp}
          />
        ),
        accessor: 'Campamento',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='N° Reserva'
            name='NroReserva'
            searcheable
            number
          />
        ),
        accessor: 'CodigoReserva',
      },
    ],
    [compani, client, site, camp, bedTypes, guest, statusType, guestTypes, selectedOn],
  )

  useEffect(() => {
    getCompanyList()
    getClientList()
    getSiteList()
    getCampList()
    getBedTypes()
    getCompanyTypes()
    getStatusTypes()
    getGuestTypes()
    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (updateTable) {
      clearSelected()
      if (pagination.currentPage === 1) {
        getChekings()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])

  useEffect(() => {
    if (clearTable) {
      if (pagination.currentPage === 1) {
        getChekings()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setClient([])
      setSite([])
      setCamp([])
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])

  useEffect(() => {
    if (currentTabItem.deleted) {
      clearSelected()
      getChekings()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.deleted])

  useEffect(() => {
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: false,
    }
    changeCurrentTabItem(obj)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // useEffect(() => {
  //   if (currentTabItem.updated) {
  //     clearSelected()
  //     getBeds()
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentTabItem.updated])

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const printPdf = (pdfUrl: any) => {
    const printWindow = window.open(pdfUrl, '_blank')
    if (printWindow) {
      printWindow.addEventListener('load', () => {
        printWindow.focus()
        printWindow.print()
      })
    }
  }

  const updateClick = () => {
    // getChekings();
    if (selectedOn.length > 0) {
      Swal.fire({
        title: '¿Estás seguro?',
        text: 'No podrás revertir esta acción',
        //showDenyButton: true,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, Check Out',
        //confirmButtonColor: 'var(--kt-primary)',
        //denyButtonText: `Don't save`,
        cancelButtonText: 'No',
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          Swal.close()
          setLoading(true)
          const {data: response} = await createCheckoutService({
            ReservaId: selectedItem.ReservaId,
            CamaId: selectedItem.CamaId,
            HuespedId: selectedItem.HuespedId,
          })
          if (response.error) {
            getSnackBarToast(response.message, 'false')
            setLoading(false)
            return
          }
          let dto = {
            reservaCamaId: selectedItem.ReservaCamaId,
            tipo: 'OUT',
            MotivoReimpresionId: '',
            Otros: '',
          }
          const response_pdf = await downloadPDFCheckInOutService(dto)
          const blob = new Blob([response_pdf.data], {
            type: 'application/pdf',
          })
          let url = window.URL.createObjectURL(blob)
          setTimeout(() => {
            printPdf(url)
          }, 1000)
          Swal.fire({
            title: 'Buen trabajo',
            html: `<div id="print_pdf">
              <button
                id='printButton'
                class='sdx_btn m-auto'
                type='button'
              >Imprimir Ticket Checkout</button>
            </div>
      <br> Se ha procesado la solicitud`,
            // html: 'Se ha procesado la solicitud',
            // showDenyButton: true,
            icon: 'success',
            showCancelButton: false,
            confirmButtonText: 'OK',
            denyButtonColor: '#283897',
            // denyButtonText: `Imprimir Ticket CheckOut`,
            // cancelButtonText: 'Imprimir Ticket CheckOut',
            showLoaderOnConfirm: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            backdrop: true,
            didOpen: () => {
              const printButton = document.getElementById('printButton') as HTMLElement
              printButton.addEventListener('click', () => printPdf(url))

              // Agregar evento de clic al botón
              // printButton.addEventListener('click', () => {
              //   printPdf(url)
              // })

              // // Simular clic en el botón después de 3 segundos
              // setTimeout(() => {
              //   printButton.click()
              // }, 3000)
            },
          }).then((result) => {
            if (result.isConfirmed) {
              Swal.close()
            }
          })

          // const handlePrintButtonClick = () => {
          //   printPdf(url) // Llamar a la función printPdf con la URL del PDF
          // }

          // // Escuchar el clic en el botón
          // document.addEventListener('click', (event) => {
          //   const target = event.target as HTMLElement
          //   if (target && target.id === 'printButton') {
          //     handlePrintButtonClick()
          //   }
          // })

          const obj: TabModel = {
            ...currentTabItem,
            showPanel: false,
            idToDelete: '',
            idToEdit: '',
          }
          changeCurrentTabItem(obj)
          setTimeout(function () {
            getChekings()
          }, 1000)
        } else if (result.isDenied) {
          //Swal.fire('Changes are not saved', '', 'info')
          Swal.close()
        }
      })
    } else {
      Swal.fire('', 'Debes seleccionar por lo menos una reserva', 'warning')
    }
  }

  return (
    <>
      <KTCard shadow className='m-5'>
        <ActionsContent
          filterClick={handleSearch}
          updateClick={updateClick}
          loading={loading}
          textComponentBack='table-checkout'
          textComponentGo='form-checkout'
        />
        {loading ? <KTableLoading title='Cargando...' /> : null}
        {isAllowed('LISTAR') && <KTable data={data} columns={columns} clearFilters />}
        <ModalSearchHuesped
          show={showModalSearch}
          setShow={setShowModalSearch}
          getChekings={getChekings}
          isCheckin={false}
        />
      </KTCard>
    </>
  )
}

const TableCheckoutWrapper = () => {
  const {isAllowed} = useHoteleria()
  return (
    <KTableProvider>
      <div className='sdx_content_tab_panel'>
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Check Out</Tab>
            {isAllowed('MASIVO') && <Tab className={'sdx_sub_tab_panel_option'}>Carga Masiva</Tab>}
          </TabList>
          <TabPanel>
            <TableCheckout />
          </TabPanel>
          {isAllowed('MASIVO') && (
            <TabPanel>
              <FormMasiveUploadCheckout />
            </TabPanel>
          )}
        </Tabs>
      </div>
    </KTableProvider>
  )
}

export {TableCheckoutWrapper}
